import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { nlNL } from "@clerk/localizations";

const appearance = {
  variables: {
    colorPrimary: "#0D5C46",
    colorPrimaryForeground: "#FFFFFF",
    colorBackground: "#FFFFFF",
    colorForeground: "#0F172A",
    fontFamily: "'DM Sans', sans-serif",
    borderRadius: "0.75rem",
  },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const localization = {
  ...nlNL,
  signIn: {
    ...nlNL.signIn,
    start: { ...nlNL.signIn?.start, title: "Inloggen bij {{applicationName}}", subtitle: "Welkom terug! Log in om verder te gaan.", titleCombined: "Inloggen bij {{applicationName}}", subtitleCombined: "Log in of maak een account aan om verder te gaan." },
  },
  signUp: {
    ...nlNL.signUp,
    start: { ...nlNL.signUp?.start, title: "Account aanmaken", subtitle: "Start gratis met {{applicationName}}" },
  },
};

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>Inloggen is nu niet beschikbaar. Vernieuw de pagina om het opnieuw te proberen.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={localization}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
